import type { BeckyModel } from '../types'

export function deStringifyExperiments(beckyExperiments: string | undefined): BeckyModel['experiments'] {
	if (!beckyExperiments) {
		return {}
	}

	const experiments: BeckyModel['experiments'] = beckyExperiments.split(',').reduce((acc, exp) => {
		const [experimentName, experimentValue] = exp.split(':')
		const truncatedExperimentName = experimentName.startsWith('.')
			? 'specs.thunderbolt' + experimentName
			: experimentName
		return {
			...acc,
			[truncatedExperimentName]: experimentValue === undefined ? true : experimentValue,
		}
	}, {})

	return fixExperimentsValues(experiments)
}

export const fixExperimentsValues = (experiments: BeckyModel['experiments'], includeFalseValues = true) => {
	if (!experiments) {
		return {}
	}

	return Object.entries(experiments).reduce<Record<string, boolean | string>>((acc, [key, value]) => {
		if (value === 'new' || value === 'true') {
			acc[key] = true
		} else if (value === 'old' || value === 'false') {
			if (includeFalseValues) {
				acc[key] = false
			}
		} else {
			acc[key] = value
		}
		return acc
	}, {})
}
